import {ZERO_DECIMALS_CURRENCIES} from '../constants';
import {getTelemetryClient} from '../telemetry';

export const convertPriceToNumber = (price: string): number => {
  // Remove all characters except digits, dots, and commas
  const cleanPrice = price.trim().replace(/[^0-9,.]/g, '');

  // Handle European number format (e.g., "1.234,56")
  const isEuropeanFormat = cleanPrice[cleanPrice.length - 3] === ',';

  return isEuropeanFormat
    ? parseFloat(cleanPrice.replace(/\./g, '').replace(/,([^,]*)$/, '.$1'))
    : parseFloat(cleanPrice.replace(/,/g, ''));
};

interface FormatPriceProps {
  currencyCode?: string;
  price: number;
}

export const formatPrice = ({
  currencyCode = 'USD',
  price,
}: FormatPriceProps): string => {
  const fractionDigits = ZERO_DECIMALS_CURRENCIES.includes(currencyCode)
    ? 0
    : 2;

  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  };

  // Try to use narrowSymbol first, fall back to symbol if not supported
  try {
    options.currencyDisplay = 'narrowSymbol';
    return new Intl.NumberFormat(undefined, options).format(price);
  } catch (narrowSymbolError) {
    options.currencyDisplay = 'symbol';
    try {
      return new Intl.NumberFormat(undefined, options).format(price);
    } catch (symbolError) {
      getTelemetryClient().log({
        body: 'Currency formatting fallback triggered',
        attributes: {
          currencyCode,
          price,
          narrowSymbolError:
            narrowSymbolError instanceof Error
              ? narrowSymbolError.message
              : String(narrowSymbolError),
          symbolError:
            symbolError instanceof Error
              ? symbolError.message
              : String(symbolError),
        },
      });

      // there are some strange cases where the fallback is failing
      // this fallback should capture any error that may occur and return a readable string
      return `${price.toFixed(fractionDigits)} ${currencyCode}`;
    }
  }
};
